import { render, staticRenderFns } from "./TreeNodeDocumentDelivery.vue?vue&type=template&id=31df1724&"
import script from "./TreeNodeDocumentDelivery.vue?vue&type=script&lang=js&"
export * from "./TreeNodeDocumentDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31df1724')) {
      api.createRecord('31df1724', component.options)
    } else {
      api.reload('31df1724', component.options)
    }
    module.hot.accept("./TreeNodeDocumentDelivery.vue?vue&type=template&id=31df1724&", function () {
      api.rerender('31df1724', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/document-package/components/TreeNodeDocumentDelivery.vue"
export default component.exports